/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CardCreateRequest } from '../models';
// @ts-ignore
import type { CardPageResponse } from '../models';
// @ts-ignore
import type { CardReactivateRequest } from '../models';
// @ts-ignore
import type { CardResponse } from '../models';
// @ts-ignore
import type { CardSuspendRequest } from '../models';
// @ts-ignore
import type { CardUpdateRequest } from '../models';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { PreconditionFailedError } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * CardsApi - axios parameter creator
 * @export
 */
export const CardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Terminates card (if it\'s active) and marks it as cancelled.
         * @summary Cancel card
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCard: async (cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('cancelCard', 'cardId', cardId)
            const localVarPath = `/cards/{card-id}`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new Card...
         * @summary Create card
         * @param {CardCreateRequest} cardCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard: async (cardCreateRequest: CardCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardCreateRequest' is not null or undefined
            assertParamExists('createCard', 'cardCreateRequest', cardCreateRequest)
            const localVarPath = `/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of a specified card.
         * @summary View card
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {boolean} [includeSecureInfo] Set to &lt;code&gt;true&lt;/code&gt; to receive full card details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard: async (cardId: string, includeSecureInfo?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCard', 'cardId', cardId)
            const localVarPath = `/cards/{card-id}`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeSecureInfo !== undefined) {
                localVarQueryParameter['includeSecureInfo'] = includeSecureInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reactivates a suspended multi-use card.
         * @summary Reactivate card
         * @param {CardReactivateRequest} cardReactivateRequest 
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCard: async (cardReactivateRequest: CardReactivateRequest, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardReactivateRequest' is not null or undefined
            assertParamExists('reactivateCard', 'cardReactivateRequest', cardReactivateRequest)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('reactivateCard', 'cardId', cardId)
            const localVarPath = `/cards/{card-id}/reactivate`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardReactivateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspends an active multi-use card.
         * @summary Suspend card
         * @param {CardSuspendRequest} cardSuspendRequest 
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendCard: async (cardSuspendRequest: CardSuspendRequest, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardSuspendRequest' is not null or undefined
            assertParamExists('suspendCard', 'cardSuspendRequest', cardSuspendRequest)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('suspendCard', 'cardId', cardId)
            const localVarPath = `/cards/{card-id}/suspend`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardSuspendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing card.
         * @summary Update card
         * @param {CardUpdateRequest} cardUpdateRequest 
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard: async (cardUpdateRequest: CardUpdateRequest, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardUpdateRequest' is not null or undefined
            assertParamExists('updateCard', 'cardUpdateRequest', cardUpdateRequest)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('updateCard', 'cardId', cardId)
            const localVarPath = `/cards/{card-id}`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of your active cards. Can be filtered.
         * @summary View card list
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [scheme] Filter by a card scheme.
         * @param {string} [productType] Filter by a card product type.
         * @param {string} [settlementCurrency] Filter by a settlement currency.
         * @param {string} [name] Card name.
         * @param {ViewCardsStatusEnum} [status] Filter by a card status.
         * @param {string} [orderReference] Filter by orderReference from the payment instruction attached to the card.
         * @param {string} [last4] Filter by card last4 numbers.
         * @param {boolean} [singleUse] Filter by single-use/multi-use cards.
         * @param {number} [pageNumber] Page number for pagination.
         * @param {number} [pageSize] Page size for pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCards: async (cardId?: string, scheme?: string, productType?: string, settlementCurrency?: string, name?: string, status?: ViewCardsStatusEnum, orderReference?: string, last4?: string, singleUse?: boolean, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cardId !== undefined) {
                localVarQueryParameter['cardId'] = cardId;
            }

            if (scheme !== undefined) {
                localVarQueryParameter['scheme'] = scheme;
            }

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }

            if (settlementCurrency !== undefined) {
                localVarQueryParameter['settlementCurrency'] = settlementCurrency;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['orderReference'] = orderReference;
            }

            if (last4 !== undefined) {
                localVarQueryParameter['last4'] = last4;
            }

            if (singleUse !== undefined) {
                localVarQueryParameter['singleUse'] = singleUse;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardsApi - functional programming interface
 * @export
 */
export const CardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Terminates card (if it\'s active) and marks it as cancelled.
         * @summary Cancel card
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCard(cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCard(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.cancelCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new Card...
         * @summary Create card
         * @param {CardCreateRequest} cardCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCard(cardCreateRequest: CardCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCard(cardCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.createCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the details of a specified card.
         * @summary View card
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {boolean} [includeSecureInfo] Set to &lt;code&gt;true&lt;/code&gt; to receive full card details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCard(cardId: string, includeSecureInfo?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCard(cardId, includeSecureInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.getCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reactivates a suspended multi-use card.
         * @summary Reactivate card
         * @param {CardReactivateRequest} cardReactivateRequest 
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateCard(cardReactivateRequest: CardReactivateRequest, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateCard(cardReactivateRequest, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.reactivateCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Suspends an active multi-use card.
         * @summary Suspend card
         * @param {CardSuspendRequest} cardSuspendRequest 
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendCard(cardSuspendRequest: CardSuspendRequest, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendCard(cardSuspendRequest, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.suspendCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing card.
         * @summary Update card
         * @param {CardUpdateRequest} cardUpdateRequest 
         * @param {string} cardId The unique ID of a card that needs to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCard(cardUpdateRequest: CardUpdateRequest, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCard(cardUpdateRequest, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.updateCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of your active cards. Can be filtered.
         * @summary View card list
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [scheme] Filter by a card scheme.
         * @param {string} [productType] Filter by a card product type.
         * @param {string} [settlementCurrency] Filter by a settlement currency.
         * @param {string} [name] Card name.
         * @param {ViewCardsStatusEnum} [status] Filter by a card status.
         * @param {string} [orderReference] Filter by orderReference from the payment instruction attached to the card.
         * @param {string} [last4] Filter by card last4 numbers.
         * @param {boolean} [singleUse] Filter by single-use/multi-use cards.
         * @param {number} [pageNumber] Page number for pagination.
         * @param {number} [pageSize] Page size for pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewCards(cardId?: string, scheme?: string, productType?: string, settlementCurrency?: string, name?: string, status?: ViewCardsStatusEnum, orderReference?: string, last4?: string, singleUse?: boolean, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewCards(cardId, scheme, productType, settlementCurrency, name, status, orderReference, last4, singleUse, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardsApi.viewCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CardsApi - factory interface
 * @export
 */
export const CardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardsApiFp(configuration)
    return {
        /**
         * Terminates card (if it\'s active) and marks it as cancelled.
         * @summary Cancel card
         * @param {CardsApiCancelCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCard(requestParameters: CardsApiCancelCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new Card...
         * @summary Create card
         * @param {CardsApiCreateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard(requestParameters: CardsApiCreateCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CardResponse> {
            return localVarFp.createCard(requestParameters.cardCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of a specified card.
         * @summary View card
         * @param {CardsApiGetCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard(requestParameters: CardsApiGetCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CardResponse> {
            return localVarFp.getCard(requestParameters.cardId, requestParameters.includeSecureInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Reactivates a suspended multi-use card.
         * @summary Reactivate card
         * @param {CardsApiReactivateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCard(requestParameters: CardsApiReactivateCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reactivateCard(requestParameters.cardReactivateRequest, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspends an active multi-use card.
         * @summary Suspend card
         * @param {CardsApiSuspendCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendCard(requestParameters: CardsApiSuspendCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suspendCard(requestParameters.cardSuspendRequest, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing card.
         * @summary Update card
         * @param {CardsApiUpdateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard(requestParameters: CardsApiUpdateCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CardResponse> {
            return localVarFp.updateCard(requestParameters.cardUpdateRequest, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of your active cards. Can be filtered.
         * @summary View card list
         * @param {CardsApiViewCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCards(requestParameters: CardsApiViewCardsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CardPageResponse> {
            return localVarFp.viewCards(requestParameters.cardId, requestParameters.scheme, requestParameters.productType, requestParameters.settlementCurrency, requestParameters.name, requestParameters.status, requestParameters.orderReference, requestParameters.last4, requestParameters.singleUse, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelCard operation in CardsApi.
 * @export
 * @interface CardsApiCancelCardRequest
 */
export interface CardsApiCancelCardRequest {
    /**
     * The unique ID of a card that needs to be modified.
     * @type {string}
     * @memberof CardsApiCancelCard
     */
    readonly cardId: string
}

/**
 * Request parameters for createCard operation in CardsApi.
 * @export
 * @interface CardsApiCreateCardRequest
 */
export interface CardsApiCreateCardRequest {
    /**
     * 
     * @type {CardCreateRequest}
     * @memberof CardsApiCreateCard
     */
    readonly cardCreateRequest: CardCreateRequest
}

/**
 * Request parameters for getCard operation in CardsApi.
 * @export
 * @interface CardsApiGetCardRequest
 */
export interface CardsApiGetCardRequest {
    /**
     * The unique ID of a card that needs to be modified.
     * @type {string}
     * @memberof CardsApiGetCard
     */
    readonly cardId: string

    /**
     * Set to &lt;code&gt;true&lt;/code&gt; to receive full card details.
     * @type {boolean}
     * @memberof CardsApiGetCard
     */
    readonly includeSecureInfo?: boolean
}

/**
 * Request parameters for reactivateCard operation in CardsApi.
 * @export
 * @interface CardsApiReactivateCardRequest
 */
export interface CardsApiReactivateCardRequest {
    /**
     * 
     * @type {CardReactivateRequest}
     * @memberof CardsApiReactivateCard
     */
    readonly cardReactivateRequest: CardReactivateRequest

    /**
     * The unique ID of a card that needs to be modified.
     * @type {string}
     * @memberof CardsApiReactivateCard
     */
    readonly cardId: string
}

/**
 * Request parameters for suspendCard operation in CardsApi.
 * @export
 * @interface CardsApiSuspendCardRequest
 */
export interface CardsApiSuspendCardRequest {
    /**
     * 
     * @type {CardSuspendRequest}
     * @memberof CardsApiSuspendCard
     */
    readonly cardSuspendRequest: CardSuspendRequest

    /**
     * The unique ID of a card that needs to be modified.
     * @type {string}
     * @memberof CardsApiSuspendCard
     */
    readonly cardId: string
}

/**
 * Request parameters for updateCard operation in CardsApi.
 * @export
 * @interface CardsApiUpdateCardRequest
 */
export interface CardsApiUpdateCardRequest {
    /**
     * 
     * @type {CardUpdateRequest}
     * @memberof CardsApiUpdateCard
     */
    readonly cardUpdateRequest: CardUpdateRequest

    /**
     * The unique ID of a card that needs to be modified.
     * @type {string}
     * @memberof CardsApiUpdateCard
     */
    readonly cardId: string
}

/**
 * Request parameters for viewCards operation in CardsApi.
 * @export
 * @interface CardsApiViewCardsRequest
 */
export interface CardsApiViewCardsRequest {
    /**
     * Filter by a card ID.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly cardId?: string

    /**
     * Filter by a card scheme.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly scheme?: string

    /**
     * Filter by a card product type.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly productType?: string

    /**
     * Filter by a settlement currency.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly settlementCurrency?: string

    /**
     * Card name.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly name?: string

    /**
     * Filter by a card status.
     * @type {'active' | 'suspended' | 'terminated'}
     * @memberof CardsApiViewCards
     */
    readonly status?: ViewCardsStatusEnum

    /**
     * Filter by orderReference from the payment instruction attached to the card.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly orderReference?: string

    /**
     * Filter by card last4 numbers.
     * @type {string}
     * @memberof CardsApiViewCards
     */
    readonly last4?: string

    /**
     * Filter by single-use/multi-use cards.
     * @type {boolean}
     * @memberof CardsApiViewCards
     */
    readonly singleUse?: boolean

    /**
     * Page number for pagination.
     * @type {number}
     * @memberof CardsApiViewCards
     */
    readonly pageNumber?: number

    /**
     * Page size for pagination.
     * @type {number}
     * @memberof CardsApiViewCards
     */
    readonly pageSize?: number
}

/**
 * CardsApi - object-oriented interface
 * @export
 * @class CardsApi
 * @extends {BaseAPI}
 */
export class CardsApi extends BaseAPI {
    /**
     * Terminates card (if it\'s active) and marks it as cancelled.
     * @summary Cancel card
     * @param {CardsApiCancelCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public cancelCard(requestParameters: CardsApiCancelCardRequest, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).cancelCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new Card...
     * @summary Create card
     * @param {CardsApiCreateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public createCard(requestParameters: CardsApiCreateCardRequest, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).createCard(requestParameters.cardCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of a specified card.
     * @summary View card
     * @param {CardsApiGetCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCard(requestParameters: CardsApiGetCardRequest, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).getCard(requestParameters.cardId, requestParameters.includeSecureInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reactivates a suspended multi-use card.
     * @summary Reactivate card
     * @param {CardsApiReactivateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public reactivateCard(requestParameters: CardsApiReactivateCardRequest, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).reactivateCard(requestParameters.cardReactivateRequest, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspends an active multi-use card.
     * @summary Suspend card
     * @param {CardsApiSuspendCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public suspendCard(requestParameters: CardsApiSuspendCardRequest, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).suspendCard(requestParameters.cardSuspendRequest, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing card.
     * @summary Update card
     * @param {CardsApiUpdateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public updateCard(requestParameters: CardsApiUpdateCardRequest, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).updateCard(requestParameters.cardUpdateRequest, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of your active cards. Can be filtered.
     * @summary View card list
     * @param {CardsApiViewCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public viewCards(requestParameters: CardsApiViewCardsRequest = {}, options?: RawAxiosRequestConfig) {
        return CardsApiFp(this.configuration).viewCards(requestParameters.cardId, requestParameters.scheme, requestParameters.productType, requestParameters.settlementCurrency, requestParameters.name, requestParameters.status, requestParameters.orderReference, requestParameters.last4, requestParameters.singleUse, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ViewCardsStatusEnum = {
    Active: 'active',
    Suspended: 'suspended',
    Terminated: 'terminated'
} as const;
export type ViewCardsStatusEnum = typeof ViewCardsStatusEnum[keyof typeof ViewCardsStatusEnum];
